export const SET_DASHBOARD_MESSAGE = "SET_DASHBOARD_MESSAGE";

const initialState = {
  save_message_disable: false,
  isMessageLoading: false,
  welcome_message_data: "",
  latest_news_data: "",
  _refetch_messages: false,
  is_show_welcome_message: false,
  is_show_latest_news: false,
  dashboardMessages: {},
  languageCode: 1,
  languageSource: "en",
  isMsgCheck: false,
  isNewsCheck: false,
};

export default (state = initialState, action = {}) =>
  action.type === SET_DASHBOARD_MESSAGE
    ? { ...state, ...action.payload }
    : state;
